import { combineReducers } from 'redux';
import alert from './alert';
import auth from './auth';
import rewards from './rewards';

export default combineReducers({
  alert,
  auth,
  rewards
});
